import { $ } from "../utils/dom";

export class Loading {
  private static singleton: Loading;
  private $container: HTMLDivElement;
  private $loading: HTMLDivElement;
  private loadingClass: string;
  private unactiveClass: string;

  constructor() {
    this.$container = $("#js__input_container") as HTMLDivElement;
    this.$loading = $("#js__loading") as HTMLDivElement;
    this.loadingClass = "main__loading square-spin";
    this.unactiveClass = "unactive main__input";
  }

  public show() {
    this.$loading.className = this.loadingClass;
    this.$container.className = this.unactiveClass;
  }

  public hide() {
    this.$loading.className = "main__loading";
    this.$container.className = "main__input";
  }

  public static get instance() {
    if (!this.singleton) {
      this.singleton = new Loading();
    }
    return this.singleton;
  }
}



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/components/loading.ts